import type { UpdateResolver } from '@urql/exchange-graphcache'
import { invalidateCache } from '../utils/invalidateCache'

const cacheInvalidateUpdaters = {}
const cacheInvalidateMutationsList = [
    'updateEntireSeries',
    'updateUpcomingSeries',
]

cacheInvalidateMutationsList.forEach((mutation) => {
    cacheInvalidateUpdaters[mutation] = (result, args, cache) => {
        invalidateCache(cache, 'meeting')
        invalidateCache(cache, 'meetingV1')
    }
})

const meetingUpdaters: Record<string, UpdateResolver> = {
    ...cacheInvalidateUpdaters,
    cancelMeetingV1: (result, args, cache) => {
        invalidateCache(cache, [
            'meeting',
            'meetingV1',
            'meetings',
            'prevMasterMeetings',
            'starredItems',
            'starredItemsV1',
        ])
    },
    updateMeeting: (result, args, cache) => {
        invalidateCache(cache, ['meeting', 'meetingV1'])
    },
    removeAttendee: (result, args, cache) => {
        invalidateCache(cache, ['meeting', 'meetingV1'])
    },
}

const metingSubscriptionsUpdaters: Record<string, UpdateResolver> = {
    meetingRefreshTriggeredV1: (_result, _args, cache) => {
        invalidateCache(cache, ['meetings', 'prevMasterMeetings'])
    },
    meetingAttendanceUpdatedV1: (result, args, cache) => {
        invalidateCache(cache, ['meeting', 'meetingV1'])
    },
}

export { meetingUpdaters, metingSubscriptionsUpdaters }
